import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PrivacyDashboard } from '@/components/PrivacyManagement/PrivacyDashboard';
import { CompanyUpdateCard } from '@/components/CompanyManagement/CompanyUpdateCard';
import { EmailTemplateCard } from '@/components/CompanyManagement/EmailTemplateCard';
import { EmailPreferencesCard } from '@/components/CompanyManagement/EmailPreferencesCard';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { getAuth } from 'firebase/auth';
import ForgotPasswordModal from '@/components/Auth/ForgotPasswordModal';
import useUser from '@/hooks/useUser';
import { isScreeningUseCase } from '@/lib/sessionCrm';

export const Route = createFileRoute('/_auth/account')({
  component: AccountPage,
});

function AccountPage() {
  const { user } = useUser();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  const auth = getAuth();
  const fbUser = auth.currentUser;
  const isGoogleUser = fbUser?.providerData.some(
    (p) => p.providerId === 'google.com',
  );

  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
    : '';

  return (
    <div className="container mx-auto py-6 px-4 max-w-2xl">
      {/* Greeting */}
      <div className="flex items-center gap-3 mb-6">
        <Avatar className="h-10 w-10">
          <AvatarImage src={user?.profile_image || ''} alt="Profile" />
          <AvatarFallback className="bg-gray-100">{initials}</AvatarFallback>
        </Avatar>
        <div>
          <p className="font-medium text-sm">
            Hello, {user?.first_name || 'there'}
          </p>
          <p className="text-xs text-gray-500">{user?.email}</p>
        </div>
      </div>

      <div className="space-y-6">
        <CompanyUpdateCard />
        {isScreeningUseCase(user?.primary_use_case) && (
          <EmailTemplateCard />
        )}
        {user?.primary_use_case !== 'learn' && <EmailPreferencesCard />}
        {!isGoogleUser && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsPasswordModalOpen(true)}
          >
            Reset password
          </Button>
        )}
        <PrivacyDashboard />
      </div>

      <ForgotPasswordModal
        open={isPasswordModalOpen}
        onOpenChange={setIsPasswordModalOpen}
      />
    </div>
  );
}
